import { Component, HostListener } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'se-button-cell-renderer',
    templateUrl: './button-cell-renderer.component.html',
    styleUrls: ['./button-cell-renderer.component.scss']
})
export class ButtonCellRendererComponent implements ICellRendererAngularComp {
    public matIcon: string;
    public onClick: (cellRendererParams: ICellRendererParams, icon: string) => void;

    private params: any;
    public icon: string;
    public visible: boolean;



    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.icon = params['matIcon'] || 'delete';
        this.visible = (!!params['checkValue']) ? !!params['value'] : true;
        this.onClick = params['onClick'];
    }

    refresh(): boolean {
        return false;
    }

    @HostListener('keydown', ['$event']) prova(ev: KeyboardEvent) {
        if (ev.altKey === false && ev.shiftKey === false && ev.ctrlKey === false) {
            if (ev.code === 'Enter' || ev.code === 'Space') {
                this.params.clicked(this.params, this.icon);
            }
        }
        return true;
    }


    _onButtonClick(event: MouseEvent) {
        if (event.detail !== 0) {
            this.onClick(this.params, this.icon);
        }
    }
}
